import { Box, withStyles } from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as PropTypes from 'prop-types';
import React from 'react';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    borderLeft: 'none',
    borderRight: 'none',
    boxShadow: 'none',
    '&:first-child': {
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
    },
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:last-child': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    minHeight: 63,
    '&$expanded': {
      minHeight: 63,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  // expanded: {},
}))(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiExpansionPanelDetails);

const CustomExpandedPanel = ({
  children,
  title,
  expanded,
  disabled,
  onChange,
  defaultExpanded,
  className,
  onClick,
}) => {
  return (
    <ExpansionPanel
      onClick={onClick}
      square
      className={className}
      expanded={expanded}
      disabled={disabled}
      onChange={onChange}
      defaultExpanded={defaultExpanded}
    >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls={`${title}-content`} id={`${title}-header`}>
        <Box fontWeight="fontWeightBold">{title}</Box>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>{children}</ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

CustomExpandedPanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  className: PropTypes.node,
};

CustomExpandedPanel.defaultProps = {};

export default CustomExpandedPanel;
